module.exports = __webpack_public_path__ + "static/media/detections.8e6f54cc.png";